import createVueComponent from '../createVueComponent';

const CornerRightUp = createVueComponent('CornerRightUpIcon', [
  ['polyline', { points: '10 9 15 4 20 9' }],
  ['path', { d: 'M4 20h7a4 4 0 004-4V4' }],
]);

export default CornerRightUp;
